var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"version2-bottom-right"},[_c('div',{staticClass:"version2-bottom-right-block"},[_c('Header',{attrs:{"title":_vm.title2 || '申请人合作情况'}}),_c('Bar',{attrs:{"options":_vm.appOptions},on:{"echartClick":_vm.echartClick}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }